import styled from "styled-components";

export const BodyDiv = styled.div`
  height: auto;
`;

export const ShortBodyDiv = styled.div`
  height: 120px;
`;
